var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "color-fillable",
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 80C62.091 80 80 62.092 80 40C80 17.91 62.091 0 40 0C17.908 0 0 17.91 0 40C0 62.092 17.908 80 40 80Z",
    fill: "#149CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "color-fillable",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 69C56.016 69 69 56.017 69 40C69 23.985 56.016 11 40 11C23.983 11 11 23.985 11 40C11 56.017 23.983 69 40 69Z",
    fill: "#149CE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0137 56C39.3568 56 38.0137 54.6569 38.0137 53C38.0137 51.3431 39.3568 50 41.0137 50C42.6705 50 44.0137 51.3431 44.0137 53C44.0137 54.6569 42.6705 56 41.0137 56Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0137 41V28C44.0137 26.3431 42.6705 25 41.0137 25C39.3568 25 38.0137 26.3431 38.0137 28V41C38.0137 42.6569 39.3568 44 41.0137 44C42.6705 44 44.0137 42.6569 44.0137 41Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamation);
export default __webpack_public_path__ + "static/media/circle-exclamation.49d344608328da9d003d4d043437d412.svg";
export { ForwardRef as ReactComponent };